<template>
  <three-step-history
    api="home-delete-request"
    :columns="columns"
    done-word="ລຶບແລ້ວ"
  />
</template>

<script>
import ThreeStepHistory from '@/views/threeStep/ThreeStepHistory.vue';

export default {
  name: 'HomeDeleteHistory',
  components: { ThreeStepHistory },
  title() {
    return 'Vientiane Waste Co-Dev|Home Delete History';
  },
  data() {
    return {
      columns: [
        { text: 'ລູກຄ້າ', value: 'customer_name' },
        { text: 'ບ້ານ', value: 'village', sortable: false },
        { text: 'ແພັກເກດ', value: 'package' },
      ],
    };
  },
};
</script>
